import { Modal, Form, Button } from '@themesberg/react-bootstrap'
import { ErrorMessage, Formik } from 'formik'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import * as Yup from 'yup'
import { getActivePromoCodesStart } from '../../../../store/redux-slices/promoCodesSlice'

const promoCodeSchema = Yup.object().shape({
  promocodesId: Yup.string().required('Please select a promo code'),
})

const PromoCodeModal = ({ show, handleClose, handleSendPromoCode, name }) => {
  const dispatch = useDispatch()
  const { activePromoCodes, activePromoCodesLoading } = useSelector((state) => state.promoCodes)

  useEffect(() => {
    if (show) {
      dispatch(getActivePromoCodesStart())
    }
  }, [show])
console.log("activePromoCodes:", activePromoCodes);
  return (
    <Formik
      initialValues={{ promocodesId: '' }}
      validationSchema={promoCodeSchema}
      onSubmit={(formValues, { resetForm }) => {
        handleSendPromoCode(formValues)
        resetForm()
        handleClose()
      }}
    >
      {({ values, touched, errors, handleChange, handleBlur, handleSubmit }) => (
        <Modal show={show} onHide={handleClose} backdrop='static' keyboard={false}>
          <Modal.Header closeButton>
            <h5>Send Promo Code to {name || 'Player'}</h5>
          </Modal.Header>
          <Modal.Body>
            <div className='form-group'>
              <label
                htmlFor='promocodesId'
                className={touched.promocodesId && errors.promocodesId ? 'text-danger' : ''}
              >
                Promo Code<span className='text-danger'> *</span>
              </label>
              <Form.Select
                name='promocodesId'
                value={values.promocodesId}
                onChange={handleChange}
                onBlur={handleBlur}
                disabled={activePromoCodesLoading}
                className={touched.promocodesId && errors.promocodesId ? 'border border-danger' : ''}
              >
                <option value=''>
                  {activePromoCodesLoading ? 'Loading...' : 'Select Promo Code'}
                </option>
                {activePromoCodes.map((c) => (
                  <option value={c.promocodesId} key={c.promocodesId}>
                    {c.code} {c.amount ? `` : ''}
                  </option>
                ))}
              </Form.Select>
              <ErrorMessage component='div' name='promocodesId' className='text-danger' />
            </div>
          </Modal.Body>
          <div className='mt-4'>
            <Modal.Footer className='d-flex justify-content-between align-items-center'>
              <Button variant='outline-warning' onClick={handleClose}>Cancel</Button>
              <Button variant='outline-success' onClick={handleSubmit} className='ml-2'>Submit</Button>
            </Modal.Footer>
          </div>
        </Modal>
      )}
    </Formik>
  )
}

export default PromoCodeModal
